import { GuideStepModel } from '@assetaccountant/core/models/onboarding/guide-step-model';
import { OnboardingRegisterGuideStepStatus } from './onboarding-register-guide-step-status';
import { OnboardingSetupGuideStep } from './onboarding-setup-guide-step';

export const setupGuideConfig = [
  {
    stepId: OnboardingSetupGuideStep.CreateRegister,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Create Asset Register',
    isSkippable: false,
  } as GuideStepModel,
  {
    stepId: OnboardingSetupGuideStep.ConnectIntegration,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Connect to Accounting Integration',
    description:
      'Integrate with partnered applications, allowing you to access features such as journal posting, importing data and more.',
    onPageDescription:
      'On the Integrations tab, press Add Integration, then choose the accounting software you want to connect to.',
    actionLabel: 'Connect Now',
    isSkippable: true,
    route: '/organisations/-/registers/-/settings#integrations',
    componentName: 'ViewSettingsComponent',
  } as GuideStepModel,
  {
    stepId: OnboardingSetupGuideStep.AddAssets,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Add Assets',
    description: 'Add your existing assets with our easy import.',
    onPageDescription:
      'For most new users the best way to add assets is by File Import with Import Assets. On the File Import tab, press New Import to start.',
    actionLabel: 'Add Assets',
    isSkippable: false,
    route: '/organisations/-/registers/-/regimes/-/periods/-/assets/add#asset-import',
    componentName: 'AddAssetsComponent',
  } as GuideStepModel,
  {
    stepId: OnboardingSetupGuideStep.MapGlAccounts,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Map General Ledger Accounts',
    description:
      'Match your General Ledger Accounts so we can post journals to your accounting integration',
    onPageDescription:
      'Select your groups and press Edit Selected General Ledger Accounts to start mapping.',
    actionLabel: 'Map Accounts',
    isSkippable: false,
    route: '/organisations/-/registers/-/regimes/-/periods/-/assetgroups/edit',
    componentName: 'AssetgroupsEditComponent',
  } as GuideStepModel,
  {
    stepId: OnboardingSetupGuideStep.AddUsers,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Add Users',
    description: 'Invite other users and set the level of permissions they have.',
    onPageDescription: 'On the Users tab, press Invite User to start adding another user.',
    actionLabel: 'Add Users',
    isSkippable: false,
    route: '/organisations/-/registers/-/settings#users',
    componentName: 'ViewSettingsComponent',
  } as GuideStepModel,
  {
    stepId: OnboardingSetupGuideStep.Completed,
    status: OnboardingRegisterGuideStepStatus.NotStarted,
    name: 'Completed',
  } as GuideStepModel,
];
